import { useEffect, useState, useRef } from "react";
import { getInstitutions } from "../api/institutionsController";

export const BankSelect = ({ onSelect, error }) => {
  const [institutions, setInstitutions] = useState(null);
  const [selected, setSelected] = useState(null);
  const [displayed, setDisplayed] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  const scrollContainerRef = useRef(null);

  const popular = [
    "barclays",
    "natwest",
    "lloyds",
    "hsbc_uk",
    "modelo-sandbox",
    "natwest-sandbox",
    "revolut-sandbox",
  ];

  useEffect(() => {
    async function fetchData() {
      const institutionData = await getInstitutions();
      setInstitutions(institutionData);
      setDisplayed(
        [...institutionData].sort(
          (a, b) => popular.includes(b.id) - popular.includes(a.id)
        )
        // .slice(0, 8)
      );
    }

    if (!institutions) {
      fetchData();
    } else {
      setDisplayed(
        [...institutions]
          .filter(
            (x) =>
              !searchTerm ||
              x.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .sort((a, b) => popular.includes(b.id) - popular.includes(a.id))
        // .slice(0, 8)
      );
    }
  }, [searchTerm]);

  const handleSelect = (x) => {
    setSelected(x.id);
    onSelect(x);
  };

  const handleScroll = () => {
    if (!scrollContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;

    setIsScrolledToTop(scrollTop <= 5);
    setIsScrolledToBottom(scrollTop + clientHeight >= scrollHeight - 5);
  };

  return (
    <>
      {error && (
        <p className="px-2 pb-2 text-red-500 text-sm">
          There was an error with your chosen bank
        </p>
      )}
      <div className="relative">
        <div
          ref={scrollContainerRef}
          onScroll={handleScroll}
          className="flex flex-col gap-2 h-[248px] mb-4 overflow-y-scroll relative py-2"
        >
          {displayed &&
            displayed.map((x) => (
              <button
                key={x.id}
                role="button"
                onClick={() => handleSelect(x)}
                className={`bg-white  ring-${
                  x.id === selected && " ring ring-inset ring-primary-500"
                } pl-3 py-4 pr-5 rounded-lg flex items-center gap-3 h-14 shadow-sm cursor-pointer`}
              >
                <img className="size-8" src={x.iconUrl} alt={x.name} />
                <span className="text-sm">{x.name}</span>
              </button>
            ))}
        </div>
        {!isScrolledToTop && (
          <div className="h-6 w-full absolute left-0 top-0 flex flex-col pointer-events-none">
            <div className="h-1 w-full bg-[#F4F4F5]" />
            <div className="bg-gradient-to-b grow from-[#F4F4F5] to-transparent" />
          </div>
        )}
        {!isScrolledToBottom && (
          <div className="h-6 w-full absolute left-0 bottom-0 flex flex-col pointer-events-none">
            <div className="bg-gradient-to-t grow from-[#F4F4F5] to-transparent" />
            <div className="h-1 w-full bg-[#F4F4F5]" />
          </div>
        )}
      </div>
      <input
        className="w-full rounded-lg p-3 mt-auto text-s bg-white focus:outline-2"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Search for your bank"
      />
    </>
  );
};
